import { render } from "./VaIconMessage.vue?vue&type=template&id=3b034c6e"
import script from "./VaIconMessage.vue?vue&type=script&lang=js"
export * from "./VaIconMessage.vue?vue&type=script&lang=js"

import "./VaIconMessage.vue?vue&type=style&index=0&id=3b034c6e&lang=scss"
script.render = render

export default script